import React from 'react';

import TimeoutImg from '@/assets/imgs/timeout-icon.svg';

import Auxiliary from '../Auxiliary';

interface DenialProps {
  handleClose: () => void;
}

export default function Timeout({ handleClose }: DenialProps) {
  return (
    <Auxiliary
      screen="timeout"
      title="Tu sesión ha caducado"
      subtitle="Vuelve a intentarlo nuevamente"
      imgSrc={TimeoutImg}
      mainButton="Volver"
      handleMainButton={() => handleClose()}
    />
  );
}
